import React from 'react';
import { Button, Toolbar } from 'devextreme-react';
import { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { hasSavedSessions } from '../persistence';

const StopwatchToolbar = ({
    rows,
    lanes,
    currentSessionId,
    savedSessions,
    swapMode,
    grid,
    onManualSave,
    onCreateNewSession,
    onToggleSwapMode,
    onRecordUnknownTime,
    onExportResults
}) => {
    // Prüfen, ob mindestens ein Sportler im Grid vorhanden ist
    const hasAthletes = grid && grid.some(row => 
        row.some(athlete => athlete !== null && athlete !== undefined)
    );

    return (
        <Toolbar>
            <ToolbarItem location="before">
                <div className="page-title">
                    {currentSessionId && (
                        <div>
                          
                                {savedSessions.find(s => s.id === currentSessionId)?.name || 'Unbekannte Sitzung'}
                          
                        </div>
                    )}
                </div>
            </ToolbarItem>
            
       
            
            <ToolbarItem location="after">
                <Button
                    text="Speichern"
                    icon="save"
                    onClick={onManualSave}
                    hint="Manuell speichern"
                />
            </ToolbarItem>
            
            
          
            
            <ToolbarItem location="after">
                <Button
                    text="Neue Sitzung"
                    icon="plus"
                    onClick={onCreateNewSession}
                    hint="Neue Sitzung erstellen"
                />
            </ToolbarItem>
            
            {/* Folgende Buttons nur anzeigen, wenn Sportler vorhanden sind */}
            {hasAthletes && (
                <>
                    <ToolbarItem location="after">
                        <Button
                            text={swapMode ? "Tausch abbrechen" : "Sportler tauschen"}
                            icon="checklist"
                            type={swapMode ? "danger" : "normal"}
                            onClick={onToggleSwapMode}
                        />
                    </ToolbarItem>
                    
                    <ToolbarItem location="after">
                        <Button
                            text="Unbekannte Zeit"
                            icon="clock"
                            type="normal"
                            onClick={onRecordUnknownTime}
                        />
                    </ToolbarItem>
                    
                    <ToolbarItem location="after">
                        <Button
                            text="Export"
                            icon="export"
                            onClick={onExportResults}
                        />
                    </ToolbarItem>
                </>
            )}
            
        
        </Toolbar>
    );
};

export default StopwatchToolbar;
